var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "page-section page-section--first page-section--last"
  }, [_c('business-heading'), _c('business-tabs', {
    attrs: {
      "titles": _vm.tabTitles
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }), _vm.tab == _vm.tabTitles[0] ? _c('business-section-0') : _vm._e(), _vm.tab == _vm.tabTitles[1] ? _c('business-section-1') : _vm._e(), _vm.tab == _vm.tabTitles[2] ? _c('business-section-2') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }